import { useState, useEffect } from 'react';
import { Box, MenuItem } from '@mui/material';
import {
  DialogContainer,
  DialogTitle,
  DialogBody,
  CustomTextField,
  CustomSelect,
  DialogActions,
} from '../../../common/components';

const GroupDialog = ({ open, onClose, onSave, selectedItem, editMode }) => {
  const [formData, setFormData] = useState({
    name: '',
    number_from: '',
    number_to: '',
    subgroup_of: '',
  });

  const [errors, setErrors] = useState({});
  const [saveAttempted, setSaveAttempted] = useState(false);

  useEffect(() => {
    if (open) {
      if (selectedItem && Object.keys(selectedItem).length > 0) {
        // Edit mode - populate with existing data
        setFormData({
          name: selectedItem?.name || '',
          number_from: selectedItem?.number_from !== undefined ? selectedItem.number_from.toString() : '',
          number_to: selectedItem?.number_to !== undefined ? selectedItem.number_to.toString() : '',
          subgroup_of: selectedItem?.subgroup_of !== undefined ? selectedItem.subgroup_of.toString() : '',
        });
      } else {
        // Add mode - reset to empty values
        setFormData({
          name: '',
          number_from: '',
          number_to: '',
          subgroup_of: '',
        });
      }
      setErrors({});
      setSaveAttempted(false);
    }
  }, [open, selectedItem]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: false,
      }));
    }
  };

  const handleSelectChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name || formData.name.trim() === '') {
      newErrors.name = true;
    }
    if (!formData.number_from || formData.number_from === '') {
      newErrors.number_from = true;
    }
    if (!formData.number_to || formData.number_to === '') {
      newErrors.number_to = true;
    }

    setErrors(newErrors);
    const isValid = Object.keys(newErrors).length === 0;
    return isValid;
  };

  const handleSave = () => {
    setSaveAttempted(true);

    if (validateForm()) {
      onSave(formData);
    } else {
    }
  };

  const handleClose = () => {
    // Reset form when closing
    setFormData({
      name: '',
      number_from: '',
      number_to: '',
      subgroup_of: '',
    });
    setErrors({});
    setSaveAttempted(false);
    onClose();
  };

  return (
    <DialogContainer open={open} onClose={handleClose} size="small">
      <DialogTitle>{editMode ? `Editar Grupo: "${formData.name}"` : 'Agregar Grupo'}</DialogTitle>
      <DialogBody sx={{ display: 'block' }}>
        <Box>
          <Box sx={{ display: 'block' }}>
            <CustomTextField
              margin="dense"
              name="name"
              label="Nombre"
              type="text"
              fullWidth
              value={formData.name}
              onChange={handleInputChange}
              error={errors.name || (saveAttempted && !formData.name)}
              helperText={
                errors.name || (saveAttempted && !formData.name) ? 'Debes ingresar un nombre.' : ''
              }
            />

            <CustomTextField
              margin="dense"
              name="number_from"
              label="N°Orden Desde"
              type="number"
              fullWidth
              value={formData.number_from}
              onChange={handleInputChange}
              error={errors.number_from || (saveAttempted && !formData.number_from)}
              helperText={
                errors.number_from || (saveAttempted && !formData.number_from)
                  ? 'Debes ingresar un N° de orden desde.'
                  : ''
              }
            />

            <CustomTextField
              margin="dense"
              name="number_to"
              label="N°Orden Hasta"
              type="number"
              fullWidth
              value={formData.number_to}
              onChange={handleInputChange}
              error={errors.number_to || (saveAttempted && !formData.number_to)}
              helperText={
                errors.number_to || (saveAttempted && !formData.number_to)
                  ? 'Debes ingresar un N° de orden hasta.'
                  : ''
              }
            />

            <CustomSelect
              label="Es sub-grupo de"
              name="subgroup_of"
              value={formData.subgroup_of}
              onChange={handleSelectChange}
              sx={{ mt: 1 }}
            >
              <MenuItem value="0">Grupo 1</MenuItem>
              <MenuItem value="1">Grupo 2</MenuItem>
            </CustomSelect>
          </Box>
        </Box>
      </DialogBody>
      <DialogActions handleClose={handleClose} handleSave={handleSave} />
    </DialogContainer>
  );
};

export default GroupDialog;
